import VJsoneditor from './VueJsoneditor'

VJsoneditor.install = function install(app) {
  app.component(VJsoneditor.name, VJsoneditor)
}

export default VJsoneditor
